module.exports = __webpack_public_path__ + "img/menu.1e3c41ae.svg";